import styled from "styled-components";
import Button from "../../components/Button/Button";

export const ZelleStyle = styled.div`
  margin-inline: 20px;
  padding-block: 75px;
`;

export const ZelleActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ZelleActions = styled(Button)`
  width: 48%;
`;
